module.exports = __webpack_public_path__ + "static/media/manu1.776177cc.png";